import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import { compose } from 'redux';
import { firebaseConnect } from 'react-redux-firebase';
import { connect } from 'react-redux';
import Fuse from 'fuse.js';

import './OrganizationsContentMembers.css';
import RemoveIcon from '../UIKit/RemoveIcon/RemoveIcon';

const getSuggestionValue = ({ displayName, email }) => displayName || email;

const renderSuggestion = ({ id, displayName, email }) => (
  <div className="OrganizationsContentMembers__suggestion">
    <div className="OrganizationsContentMembers__suggestion__left">
      {displayName}
    </div>
    <div className="OrganizationsContentMembers__suggestion__right">
      {email}
    </div>
  </div>
);

class AddNewMemberSection extends Component {
  constructor() {
    super();

    this.state = {
      value: '',
      suggestions: []
    };
  }

  onChange(event, { newValue, method }) {
    let value = newValue;

    this.setState({
      value,
    });
  }

  onSuggestionSelected(e, { suggestion }) {
    const { organization, firebase } = this.props;
    this.setState({
      value: '',
    });

    firebase.set(`/organizations/${organization.id}/members/${suggestion.id}`, true);
  }

  onSuggestionsFetchRequested({ value }) {
    const { users, members } = this.props;
    const options = {
      id: 'id',
      shouldSort: true,
      threshold: 0.4,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: [
        'displayName',
        'email'
      ]
    };
    const fuse = new Fuse(this.props.users, options);
    const result = fuse.search(value);
    const memberIds = members.map(({ id }) => id);
    const filtered = result.reduce((acc, curr) => {
      if (memberIds.includes(curr) === false) {
        acc.push(users.filter(({ id }) => id === curr)[0]);
      }

      return acc;
    }, []);

    this.setState({
      suggestions: filtered,
    });
  }

  onSuggestionsClearRequested() {
    this.setState({
      suggestions: []
    });
  }

  render() {
    const { value, suggestions } = this.state;

    const inputProps = {
      placeholder: 'Type a name of an user',
      value,
      onChange: this.onChange.bind(this),
    };

    return (

      <div className="OrganizationsContentDetails__box">
        <h2 className="OrganizationsContentDetails__box__header">
          Add new member
        </h2>
        <div className="OrganizationsContentDetails__box__content"
             style={{ display: 'flex', flex: '1 1 auto' }}>
          <Autosuggest
            suggestions={suggestions}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested.bind(this)}
            onSuggestionsClearRequested={this.onSuggestionsClearRequested.bind(this)}
            onSuggestionSelected={this.onSuggestionSelected.bind(this)}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            inputProps={inputProps}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ firebase }, { match }) => {
  const uid = firebase.auth.uid;
  const organization = firebase.data.organizations[match.params.organizationId];
  const owners = Object.keys(organization.owners).reduce((acc, curr) => {
    if (organization.owners[curr] !== true) {
      return acc;
    }

    acc.push({
      id: curr,
      ...firebase.data.users[curr],
    });

    return acc;
  }, []);

  const users = Object.keys(firebase.data.users).reduce((acc, curr) => {
    if (firebase.auth.uid !== curr) {
      acc.push({
        id: curr,
        ...firebase.data.users[curr],
      })
    }

    return acc;
  }, []);

  const members = Object.keys(organization.members).reduce((acc, curr) => {
    if (curr !== uid) {
      acc.push({
        id: curr,
        ...firebase.data.users[curr],
      });
    }

    return acc;
  }, []);

  return ({
    users,
    organization,
    owners,
    members,
    uid,
  });
};

const OrganizationsContentMembers = (props) => {
  const isOwner = props.owners.map(({id}) => id).includes(props.uid);

  const removeMember = (id) => {
    const { organization, firebase } = props;

    if (isOwner === true) {
      firebase.remove(`/organizations/${organization.id}/members/${id}`);
    }
  };

  const mapPeople = (people, type) => people.map(({ id, displayName, email }) => (
    <tr key={`${displayName}${email}`}>
      <td>
        {displayName}
      </td>
      <td>
        {email}
      </td>
      <td>
        {type}
      </td>
      <td>
        {type !== 'owner' && isOwner && (
          <button
            onClick={() => {
              removeMember(id);
            }}
            className="OrganizationsContentMembers__remove-button"
          >
            <RemoveIcon />
          </button>
        )}
      </td>
    </tr>
  ));

  const ownerElems = mapPeople(props.owners, 'owner');
  const memberElems = mapPeople(props.members, 'member');

  let membersContent = (
    <div style={{ fontSize: 12 }}>
      There are no members in this group. { isOwner && 'Let\'s add some' }
    </div>
  );

  if (props.members.length + props.owners.length > 0) {
    membersContent = (
      <table className="table" style={{ width: '100%', fontSize: 12 }}>
        <tbody>
        {ownerElems}
        {memberElems}
        </tbody>
      </table>
    );
  }

  return (
    <div className="OrganizationsContentMembers">
      <div className="OrganizationsContentDetails__box">
        <h2 className="OrganizationsContentDetails__box__header">
          Members
        </h2>
        <div className="OrganizationsContentDetails__box__content"
             style={{ display: 'flex', flex: '1 1 auto' }}>
          { membersContent }
        </div>
      </div>
      { isOwner && <AddNewMemberSection {...props} /> }
    </div>
  );
};

export default compose(
  firebaseConnect(() => [
    { path: 'users' }
  ]),
  connect(mapStateToProps),
)(OrganizationsContentMembers);



// WEBPACK FOOTER //
// ./src/components/OrganizationsContentMembers/OrganizationsContentMembers.jsx